import { render, staticRenderFns } from "./QToggle.vue?vue&type=template&id=63d95efc&scoped=true"
import script from "./QToggle.vue?vue&type=script&lang=js"
export * from "./QToggle.vue?vue&type=script&lang=js"
import style0 from "./QToggle.vue?vue&type=style&index=0&id=63d95efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d95efc",
  null
  
)

/* custom blocks */
import block0 from "./QToggle.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports